import { API_URL } from "~/Core/Hooks/utils/constant";
import type { SupplierAttachmentViewType } from "~/Core/Models";

import axios from "./config";

const SCHEMA = "/supplier/attachment";

export function Download({ filePath }: { filePath: string | number }) {
  return axios.get(`${API_URL}${SCHEMA}/download/${filePath}`, { responseType: "blob" });
}
export function DownloadByUrl({ filePath }: { filePath: string | number }) {
  return axios.get(`${filePath}`, { responseType: "blob" });
}

export function Upload({ type, file }: { type: SupplierAttachmentViewType; file: File }) {
  const data = new FormData();
  // data.append("type", type);
  data.append(`file`, file);
  return axios.post(`${SCHEMA}/upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: { type },
  });
}
